import { StaticQuery, graphql } from "gatsby"
import CustomLink from "../Link"
import cx from "classnames"
import React, { useEffect, useState } from "react"
import styled from "@emotion/styled"

import Dropdown from "./dropdown"
import "./navigation.scss"

const NavigationMobile = props => {
  const { data } = props
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const Nav = styled.nav`
    background: ${props.active_navigation !== "true"
      ? "linear-gradient(180deg, #000000 0, rgba(0, 0, 0, 0) 100%)"
      : "black"};
  `

  useEffect(() => {
    if (isMenuOpen) {
      document
        .getElementById("navigation__hamburger")
        .setAttribute("aria-label", "Close the menu")
    } else {
      document
        .getElementById("navigation__hamburger")
        .setAttribute("aria-label", "Open the menu")
    }

    if (props.active_navigation === undefined) {
      window.addEventListener("scroll", handleScroll)

      return () => {
        window.removeEventListener("scroll", handleScroll)
      }
    }
  })

  const checkEnterKeypress = event => {
    const ENTER_KEY = 13
    if (event.keyCode === ENTER_KEY) {
      setIsMenuOpen(!isMenuOpen)
    }
  }

  function handleScroll() {
    const navigation = document.querySelector(".navigation--mobile")

    if (
      document.body.scrollTop > 60 ||
      document.documentElement.scrollTop > 60
    ) {
      navigation.style.background = "#000"
    } else {
      navigation.style.background =
        "linear-gradient(180deg, #000000 0%, rgba(0,0,0,0) 100%)"
    }
  }

  return (
    <Nav className="navigation navigation--mobile">
      <div
        className="navigation__overlay"
        style={
          isMenuOpen
            ? {
                zIndex: "1",
                opacity: "1",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              }
            : {}
        }
      />
      <div className="container">
        <CustomLink url={"/"} activeClassName="active">
          <div className="navigation__logo--mobile">
            <img
              src={data.contentstackDraftkingsLogos.draftkings_d_crown.url}
              alt="Brand Logo"
            />
          </div>
        </CustomLink>
        <div
          className={cx("navigation__hamburger", { active: isMenuOpen })}
          id="navigation__hamburger"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          role="button"
          tabIndex="0"
          aria-expanded={isMenuOpen}
          onKeyDown={checkEnterKeypress}
        >
          <span />
          <span />
        </div>
        <ul
          className="navigation__list--mobile"
          style={isMenuOpen ? { right: "0" } : {}}
        >
          {data.contentstackMenu.menu_items.map(menuItem => {
            if (menuItem.url.title !== "Home") {
              if (menuItem.url.href !== "") {
                return (
                  <li key={menuItem.url.title} className="navigation__label">
                    <CustomLink
                      activeClassName="active"
                      className="navigation__link"
                      url={menuItem.url.href}
                    >
                      {menuItem.url.title}
                    </CustomLink>
                  </li>
                )
              } else {
                return <Dropdown menuItem={menuItem} key={menuItem.url.title} />
              }
            }

            return false
          })}
          <span className="target" />
        </ul>
      </div>
    </Nav>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        contentstackMenu {
          menu_items {
            url {
              title
              href
            }
            submenu {
              url {
                title
                href
              }
            }
          }
          sign_up_desktop_link {
            title
            href
          }
          sign_up_mobile_link {
            title
            href
          }
        }
        contentstackDraftkingsLogos {
          draftkings_d_crown {
            url
          }
          draftkings_stacked_logo {
            url
          }
        }
      }
    `}
    render={data => <NavigationMobile data={data} {...props} />}
  />
)
